var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-container"},[_c('div',{staticClass:"trading-main"},[_c('tradingAside'),_c('div',{staticClass:"trading-content"},[_c('tradingTop'),_c('tradingView'),_c('tradingFormWrap')],1),_c('tradingRight')],1),_c('div',{staticClass:"trading-bottom"},[_c('tradingOrders')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }